import { CAMPAIGNS_QUERY_ACTION_PARAM } from '@/lib/albums/queryParams';
import {
    ANALYZE_COMMUNITY,
    ANALYZE_CONTENT,
    ANALYZE_ENGAGEMENT,
    ANALYZE_OVERVIEW,
    CONTENT_ALBUMS,
    CONTENT_ALBUMS_COMPARATIVE_TABLE,
    CONTENT_ALBUM_ANALYTICS,
    CONTENT_ALBUM_POSTS,
    CONTENT_ALBUM_STATS,
    CONTENT_POSTS,
    DASHBOARD,
    DASHBOARD_CUSTOMIZATION,
    DASHBOARD_GENERATE_CUSTOM_REPORT,
    DASHBOARD_VIEW,
    REPORTS,
    REPORTS_ACCOUNTS,
    REPORTS_COMPETITORS,
    REPORTS_DASHBOARDS,
    REPORTS_EDIT,
    REPORTS_HASHTAGS,
    INSPIRATION
} from '@/routes/privateRoutes';

import type { MainMenuType } from '@/lib/menu/main';

const mainYoutube: MainMenuType = [
    // Dashboard
    {
        icon: 'dashboard',
        link: DASHBOARD,
        name: 'commons:menu.dashboard',
        urlActiveMenu: [DASHBOARD_VIEW, DASHBOARD_CUSTOMIZATION, DASHBOARD_GENERATE_CUSTOM_REPORT]
    },
    // Analytics
    {
        icon: 'analytics',
        name: 'menu.analytics',
        subMenuItems: [
            {
                icon: 'eye',
                link: ANALYZE_OVERVIEW,
                name: 'commons:menu.overview'
            },
            {
                icon: 'engagement',
                link: ANALYZE_ENGAGEMENT,
                name: 'commons:menu.engagement'
            },
            {
                icon: 'comments',
                link: ANALYZE_COMMUNITY,
                name: 'commons:menu.community'
            },
            {
                icon: 'content',
                link: ANALYZE_CONTENT,
                name: 'commons:menu.content'
            }
        ]
    },
    // Reports
    {
        icon: 'reports',
        link: REPORTS,
        name: 'commons:menu.exports_reports',
        urlActiveMenu: [
            REPORTS_EDIT,
            REPORTS_ACCOUNTS,
            REPORTS_DASHBOARDS,
            REPORTS_COMPETITORS,
            REPORTS_HASHTAGS
        ]
    },
    // Content
    {
        icon: 'content',
        name: 'commons:menu.content',
        quickAccess: {
            label: 'commons:menu.track_campaign',
            icon: 'plus',
            link: {
                pathname: CONTENT_ALBUMS,
                query: {
                    [CAMPAIGNS_QUERY_ACTION_PARAM.NAME]:
                        CAMPAIGNS_QUERY_ACTION_PARAM.VALUES.TRACK_CAMPAIGN
                }
            }
        },
        subMenuItems: [
            {
                icon: 'content',
                link: CONTENT_POSTS,
                name: 'commons:menu.posts'
            },
            {
                icon: 'albums',
                link: CONTENT_ALBUMS,
                name: 'commons:menu.albums',
                urlActiveMenu: [
                    CONTENT_ALBUM_POSTS,
                    CONTENT_ALBUM_ANALYTICS,
                    CONTENT_ALBUM_STATS,
                    CONTENT_ALBUMS_COMPARATIVE_TABLE
                ]
            }
        ]
    },
    // Inspiration
    {
        icon: 'inspiration',
        link: INSPIRATION,
        name: 'commons:menu.inspiration'
    }
];

export default mainYoutube;
